import { Cushion, MaxWidth, Rectangle, Shadow } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon from '../icon';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import TEAM_PROP_TYPES from '../../lib/prop-types/team';
import SecondaryNavContainer from '../navigation/secondary-navigation-container';
import useBreakpoint from '../../lib/use-breakpoint';
import FilterIconWrapper from '../navigation/mobile/filter-icon-wrapper';
import TeamFilter from '../navigation/team-filter';
import SearchBox from './search-box';

const FilterBar = ({ club, onChangeTeamFilter, onSearchChange, search, team }) => {
  const isMobile = useBreakpoint();
  const [isTeamFilterOpen, setTeamFilterOpen] = useState(false);
  const [isSearchOpen, setSearchOpen] = useState(search.length > 0);
  const onSearchCancelHandler = () => {
    setSearchOpen(false);
    onSearchChange('');
  };

  const onSearchOpenHandler = () => {
    setSearchOpen(true);
  };

  const searchInputMount = (input) => {
    if (input && search.length === 0) {
      input.focus();
    }
  };

  const searchBox = (
    <SearchBox
      key={`search-${search}`}
      onSearchChange={onSearchChange}
      onSearchCancel={onSearchCancelHandler}
      inputRef={searchInputMount}
      initialSearchTerm={search}
      showClose={isMobile || search}
    />
  );

  return (
    <>
      <SecondaryNavContainer title="Media">
        {isMobile ? (
          <>
            <FilterIconWrapper
              filterName="search"
              filterValue={search}
              onFilterClick={() => (isSearchOpen ? onSearchCancelHandler() : onSearchOpenHandler())}
            >
              <Icon name="search" size={20} />
            </FilterIconWrapper>
            <FilterIconWrapper
              filterName="team"
              filterValue={team?.name}
              onFilterClick={() => setTeamFilterOpen(!isTeamFilterOpen)}
              isLastInRow
            >
              <Icon name="t-shirt" size={20} />
            </FilterIconWrapper>
          </>
        ) : (
          <>
            {searchBox}
            <FilterIconWrapper
              filterName="team"
              filterValue={team?.name}
              onFilterClick={() => setTeamFilterOpen(!isTeamFilterOpen)}
              isLastInRow
            >
              <Icon name="t-shirt" size={20} />
            </FilterIconWrapper>
          </>
        )}
      </SecondaryNavContainer>
      {isMobile && isSearchOpen && (
        <Rectangle fill="#fff">
          <Cushion all="medium" component="div">
            {searchBox}
          </Cushion>
        </Rectangle>
      )}
      <div
        style={{
          maxHeight: isTeamFilterOpen ? 9999 : 0,
          overflow: 'hidden',
          transition: 'max-height .5s ease',
        }}
      >
        <Shadow>
          <Rectangle fill="#fff" borderTop="thinLightGrey">
            <Cushion horizontal="large" vertical="xlarge" component="div">
              <MaxWidth component="div" maxWidth={1366} center>
                <TeamFilter
                  onChange={(value) => {
                    setTeamFilterOpen(false);
                    onChangeTeamFilter(value);
                  }}
                  sections={club.sections}
                  selected={team ? team.id : null}
                />
              </MaxWidth>
            </Cushion>
          </Rectangle>
        </Shadow>
      </div>
    </>
  );
};

FilterBar.defaultProps = {
  search: '',
  team: null,
};

FilterBar.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  onChangeTeamFilter: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  search: PropTypes.string,
  team: TEAM_PROP_TYPES,
};

export default FilterBar;
